const routes = [
  {
    path: '/relatorio/veiculos/abastecimento',
    name: 'reportVehicleFuel',
    component: () => import('@/views/relatorio/frotas/Abastecimento.vue'),
    meta: { breadcrumb: [{ title: 'Relatórios' }, { title: ' Veículos' }, { title: 'Abastecimento' }] },
  },
  {
    path: '/relatorio/veiculos/manutencao',
    name: 'reportVehicleMaintenance',
    component: () => import('@/views/relatorio/frotas/Manutencao.vue'),
    meta: { breadcrumb: [{ title: 'Relatórios' }, { title: ' Veículos' }, { title: 'Manutenção' }] },
  },
  // {
  //   path: '/relatorio/historico-veiculos',
  //   name: 'vehiclesHistory',
  //   component: () => import('old/HistoricoVeiculos.vue'),
  //   meta: { breadcrumb: [{ title: 'Relatórios' }, { title: 'Relatório de Histórico de Veículos' }] },
  // },
]

export default routes
